import { useEffect, useLayoutEffect } from "react";

const MOUSEDOWN = "mousedown";
const useOutlineEnhancer = () => {
  useLayoutEffect(() => {
    if (!document.body.classList.contains(MOUSEDOWN)) {
      document.body.classList.add(MOUSEDOWN);
    }
  }, []);

  useEffect(() => {
    const handleMouseDown = () => {
      if (!document.body.classList.contains(MOUSEDOWN)) {
        document.body.classList.add(MOUSEDOWN);
      }
    };

    const handleTouchStart = () => {
      if (!document.body.classList.contains(MOUSEDOWN)) {
        document.body.classList.add(MOUSEDOWN);
      }
    };

    const handleKeyDown = () => {
      if (document.body.classList.contains(MOUSEDOWN)) {
        document.body.classList.remove(MOUSEDOWN);
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("touchstart", handleTouchStart, { passive: true });
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};

export default useOutlineEnhancer;
